import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { UrlConstantes } from '../utilerias/constantes/urlconstantes';
import { Cliente } from '../shared/model/ajustesUsuario/cliente.model';
import { ConsultaList } from '../shared/model/core/ConsultaList.model';
import { TipoCliente } from '../shared/model/ajustesUsuario/tipo.cliente';
import { SegmentoCliente } from '../shared/model/ajustesUsuario/segmento.cliente';
import { TamanioCliente } from '../shared/model/ajustesUsuario/tamanio.cliente';
import { UsuarioClienteBean } from '../shared/model/ajustesUsuario/usuarioClienteBean.model';
import { Prospeccion } from './models/prospeccion';
import { SeguimientoProspeccion } from './models/seguimientoProspeccion';



const API_URL = environment.apiUrl;
@Injectable({
  providedIn: 'root'
})
export class GestionclientesService {

  constructor(private route: ActivatedRoute, private router: Router, private httpClient: HttpClient) { }

  saveUpdateCLient(data: Cliente) {
    return this.httpClient.post<Cliente>(UrlConstantes.agregaActualizaCliente, data);
  }

  deleteClient(status: Cliente) {
    return this.httpClient.post<Cliente>(UrlConstantes.eliminarCliente, status);
  }
  filtroBusquedaCliente(filtro: ConsultaList<Cliente>) {
    return this.httpClient.post<ConsultaList<Cliente>>(UrlConstantes.filtroClientes, filtro);
  }

  filtroBusquedaClienteGestion(filtro: ConsultaList<Cliente>) {
    return this.httpClient.post<ConsultaList<Cliente>>(UrlConstantes.filtroClientesGestion, filtro);
  }

  filtroBusquedaUsuariosCliente(filtro: ConsultaList<UsuarioClienteBean>) {
    return this.httpClient.post<ConsultaList<UsuarioClienteBean>>(UrlConstantes.filtroUsuariosClientes, filtro);
  }

  consultaTipos(tipo:TipoCliente) {
    return this.httpClient.post<ConsultaList<TipoCliente>>(UrlConstantes.consultaTiposCliente, tipo);
  }
  
  consultaSegmento(segmento:SegmentoCliente) {
    return this.httpClient.post<ConsultaList<SegmentoCliente>>(UrlConstantes.consultaSegmentoCliente, segmento);
  }

  consultaTamanio(tam : TamanioCliente ) {
    return this.httpClient.post<ConsultaList<TamanioCliente>>(UrlConstantes.consultaTamanioCliente, tam);
  }

  // consultaProspectos(pros: Prospeccion) {
  //   return this.httpClient.post<ConsultaList<Prospeccion>>(
  //     API_URL + 'controller/consultaProspectos.do',
  //     pros,
  //     {}
  //   ); 
  // }

  consultaProspectos(filtro: ConsultaList<Prospeccion>) {
    return this.httpClient.post<ConsultaList<Prospeccion>>(UrlConstantes.CONSULTA_PROSPECTOS, filtro);
  }

  guardarSeguimiento(seguimiento: SeguimientoProspeccion) {
    return this.httpClient.post<SeguimientoProspeccion>(UrlConstantes.GUARDAR_SEGUIMIENTO_PROSPECTO, seguimiento, {});
  }

  guardarProspecto(prospecto: Prospeccion) {
    return this.httpClient.post<Prospeccion>(UrlConstantes.GUARDAR_PROSPECTO, prospecto, {});
  }

  consultaSeguimiento(idProspecto: number) {
    return this.httpClient.post<ConsultaList<SeguimientoProspeccion>>(
      API_URL + 'controller/consultaSeguimiento.do',
      idProspecto,
      {}
    ); 
  }

  consultaProspectosxUsuarioSeguimiento(filtro: ConsultaList<Prospeccion>) {
    return this.httpClient.post<ConsultaList<Prospeccion>>(UrlConstantes.CONSULTA_PROSPECCION_USER_SEGUIMIENTOS, filtro);
  }
}
